import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

const CancelButton = ({ onClick, disabled }) => {
  const { t } = useTranslation();
  return (
    <>
      <Button
        onClick={() => onClick()}
        disabled={disabled}
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: "14px 20px",
          width: "100px",
          height: "52px",
          background: "##FFFFFF",
          borderRadius: "8px",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "20px",
          color: "#1B2430",
          border: "1px solid #E0E0E0",
          "&:hover ": {
            background: "#c2cbcf",
            borderRadius: "8px",
            color: "white",
          },
        }}
      >
        {t("Cancel")}
      </Button>
    </>
  );
};

export default CancelButton;
